
import { motion } from "framer-motion";
import { Lightbulb } from "lucide-react";

interface QuizExplanationProps {
  text: string;
  visible: boolean;
}

const QuizExplanation = ({ text, visible }: QuizExplanationProps) => {
  if (!visible) return null;
  
  return (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      transition={{ duration: 0.5 }}
      className="mt-4 mb-6 bg-[#FFF8E7] border border-[#FBC528] rounded-lg p-4"
    >
      <div className="flex items-start">
        <Lightbulb className="w-5 h-5 text-cta-yellow mt-0.5 mr-3 flex-shrink-0" />
        <p className="text-[#212529]">{text}</p>
      </div>
    </motion.div>
  );
};

export default QuizExplanation;
